import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components';
import { H3 } from 'UIComponents/elements/headings';
import { GYPSUM } from 'HubStyleTokens/colors';
const StyledSectionTitle = styled(H3).attrs(() => ({
  'aria-level': '3'
})).withConfig({
  displayName: "MobilePanelNav__StyledSectionTitle",
  componentId: "ccyu5x-0"
})(["&&{padding:10px 20px;background-color:", ";height:35px;font-weight:bold;line-height:normal;font-size:14px;margin-bottom:0;}"], GYPSUM);
StyledSectionTitle.displayName = 'StyledSectionTitle';

const MobilePanelNav = ({
  children,
  title
}) => {
  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsx(StyledSectionTitle, {
      children: title
    }), children]
  });
};

export default MobilePanelNav;